import { Row, Col, Card, Skeleton, Tag, Image, Table } from "antd";
import React, { useState, useEffect, useRef } from "react";
import { Link, useParams } from "react-router-dom";
import useRequest from "../../hooks/useRequest";
import { ShowToast, Severty } from "../../helper/toast";
import apiPath from "../../constants/apiPath";
import { Badge } from 'antd';
import moment from "moment";
import { formatDate } from "../../helper/DateHelper";
import notfound from "../../assets/images/not_found.png";
import { useLocation } from "react-router-dom";

function View() {

  const sectionName           =   "Brand";
  const routeName             =   "brand";
  
  const location              =   useLocation();
  const params                =   useParams();
  const { request }           =   useRequest();
  const [list, setList]       =   useState({});
  const [loading, setLoading] =   useState(false);

  const fetchData = (id) => {
    request({
      url       :   apiPath.viewBrand + "/" + id,
      method    :   'GET',
      onSuccess :   (data) => {
        setLoading(false);
        setList(data.data);
      },
      onError: (error) => {
        ShowToast(error, Severty.ERROR)
      }
    })
  }

  useEffect(() => {
    setLoading(true)
    fetchData(params.id)
  }, [])

  return (
    <>
      <Row gutter={16}>
        <Col span={12} xs={24} md={24} className="mb-2">
          <Card title={sectionName + " Details"}>
            <Row gutter={16}>
              <Col span={12} xs={24} md={24}>

                {loading ? <Skeleton active /> : 
                  <div className="view-main-list">

                    <div className="view-inner-cls">
                      <h5>Verified:</h5>
                      <h6>{list.is_verify ? <Badge colorSuccess status="success" text="Verified" /> : <Badge status="error" text="Not Verified" />}</h6>
                    </div>

                    <div className="view-inner-cls">
                      <h5>Logo:</h5>
                      <h6><Image className="imagefix" width={80} height={80} src={list && list.logo ? list.logo : notfound} /></h6>
                    </div>

                    <div className="view-inner-cls">
                      <h5>Brand Name:</h5>
                      <h6>{list.name ? list.name : '-'}</h6>
                    </div>

                    <div className="view-inner-cls">
                      <h5>Brand Identity Number:</h5>
                      <h6>{list.sp_code ? list.sp_code : '-'}</h6>
                    </div>
                
                    <div className="view-inner-cls">
                      <h5>Category:</h5>
                      <h6><span className="cap">{list?.category_id && list.category_id.name ? list.category_id.name : '-'}</span></h6>
                    </div>

                    <div className="view-inner-cls">
                      <h5>City:</h5>
                      <h6>
                        <span className="cap">
                          {list?.city_selection === 'Single City'
                            ? list?.city_id?.name || '-'
                            : list?.city_selection || '-'}
                        </span>
                      </h6>
                    </div>

                    <div className="view-inner-cls">
                      <h5>Cluster:</h5>
                      <h6><span className="cap">{list?.cluster_id && list.cluster_id.name ? list.cluster_id.name : '-'}</span></h6>
                    </div>

                    <div className="view-inner-cls">
                      <h5>Tag(s):</h5>
                      <h6>
                        <span className="cap">
                          {
                            list?.tag_id && list.tag_id?.length > 0 ? list.tag_id.map((tag, index) => (
                              <div className="mb-1" key={tag._id}>
                                {index + 1}) {tag.title}
                              </div>
                            ))
                            : '-'
                          }
                        </span>
                      </h6>
                    </div>

                    <div className="view-inner-cls">
                      <h5>Short Description:</h5>
                      <h6><span className="cap">{list?.short_description ?? '-'}</span></h6>
                    </div>

                    <div className="view-inner-cls">
                      <h5>Long Description:</h5>
                      <h6><span className="cap">{list?.long_description ?? '-'}</span></h6>
                    </div>

                    <div className="view-inner-cls">
                      <h5>Status:</h5>
                      <h6>{list.is_active ? <Badge colorSuccess status="success" text="Active" /> : <Badge status="error" text="InActive" />}</h6>
                    </div>

                    <div className="view-inner-cls">
                      <h5>Created On:</h5>
                      <h6>{formatDate(list.created_at)}</h6>
                    </div>

                    <div className="view-inner-cls float-right">
                      <Link
                        className="ant-btn ant-btn-secondary"
                        to={`/${routeName}${location.search}`}
                      >
                        <i class="fas fa-arrow-left mr-5"></i> Back
                      </Link>
                    </div>
                  </div>
                }
              </Col>
            </Row>
          </Card>
        </Col>
    
        <Col span={12} xs={24} md={24}>
          <Card title={"Product Service"}>
            <Row gutter={16}>
              <Col span={12} xs={24} md={24}>

                {loading ? <Skeleton active /> : 
                  <div className="view-main-list">

                    <div className="view-inner-cls">
                      <ul className="product-service-list">
                        {list?.psl_list && list.psl_list.length > 0 ? (list.psl_list.map((psl, pslIndex) => (
                            
                            <li key={pslIndex} className="psl-item">
                              <div className="cap"> <strong>{psl.psl_name}</strong> </div>

                              {psl.ps_list && psl.ps_list.length > 0 && (
                                <ul className="ps-list">
                                  {psl.ps_list.map((ps, psIndex) => (
                                    <li key={psIndex} className="ps-item">
                                      
                                      <div className="cap mt-1 mb-1"> <strong>{ps.ps_name}</strong> </div>

                                      {ps.psla_list && ps.psla_list.length > 0 && (
                                        <div className="table-responsive">
                                          <table className="table table-bordered table-striped align-middle">
                                            <thead className="table-light">
                                              <tr>
                                                <th scope="col">Label</th>
                                                <th scope="col">Type</th>
                                                <th scope="col">Required</th>
                                                <th scope="col">Display Summary</th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              {ps.psla_list.map((psla, pslaIndex) => (
                                                <tr key={pslaIndex}>
                                                  <td>{psla.psla_label || "-"}</td>
                                                  <td>{psla.psla_type || "-"}</td>
                                                  <td>
                                                    <span
                                                      className={`${
                                                        psla.psla_required == 'Yes' ? "text-success" : "text-danger"
                                                      }`}
                                                    >
                                                      {psla.psla_required || '-'}
                                                    </span>
                                                  </td>
                                                  <td>
                                                    <span
                                                      className={`${
                                                        psla.psla_display_summary == 'Yes' ? "text-success" : "text-danger"
                                                      }`}
                                                    >
                                                      {psla.psla_display_summary || '-'}
                                                    </span>
                                                  </td>
                                                </tr>
                                              ))}
                                            </tbody>
                                          </table>
                                        </div>
                                      )}
                                    </li>
                                  ))}
                                </ul>
                              )}
                            </li>
                          ))
                        ) : (
                          <li>No product services available</li>
                        )}
                      </ul>
                    </div>

                  </div>
                }

              </Col>
            </Row>
          </Card>
        </Col>
      </Row>

      <Row gutter={16} className="mb-2">
        <Col span={12} xs={24} md={24} className="mt-2">
          <Card 
            title="Contact Details" 
            bordered={false}
            className="shadow-md rounded-2xl"
          >
            <Row gutter={16}>
              <Col span={24}>
                {loading ? (
                  <Skeleton active />
                ) : (
                  <div className="view-main-list">
                    {list?.contact_detail && list.contact_detail.length > 0 ? (
                      <Table
                        dataSource={list.contact_detail}
                        rowKey={(record, index) => index}
                        pagination={false}
                        bordered
                        size="middle"
                      >
                        <Table.Column 
                          title="Label" 
                          dataIndex="label" 
                          key="label"
                          render={(text) => text || "No Label"} 
                        />
                        
                        <Table.Column 
                          title="Value" 
                          dataIndex="value" 
                          key="value"
                          render={(text, record) => {

                            if (record.type === "Hyperlink") {
                              const raw = (record?.hyperlink ?? record?.url ?? record?.href ?? record?.link ?? text ?? "").toString().trim();

                              const embedded = (raw || "").match(/https?:\/\/[^\s]+/i);
                              let candidate = embedded ? embedded[0] : raw;

                              if (!/^https?:\/\//i.test(candidate)) {
                                if (/^www\./i.test(candidate) || /^([a-z0-9-]+\.)+[a-z]{2,}(\/.*)?$/i.test(candidate)) {
                                  candidate = `https://${candidate}`;
                                } else {
                                  return text || "-";
                                }
                              }

                              const href = encodeURI(candidate);
                              
                              return (
                                <a 
                                  href={href} 
                                  target="_blank" 
                                  rel="noopener noreferrer"
                                  className="text-blue-600 hover:underline"
                                >
                                  {text || href}
                                </a>
                              );
                            }

                            if (!text) return "-";

                            if (record.type === "Email Address") {
                              return (
                                <a 
                                  href={`mailto:${text}`} 
                                  className="text-blue-600 hover:underline"
                                >
                                  {text}
                                </a>
                              );
                            }

                            if (record.type === "Phone Number") {
                              return (
                                <a 
                                  href={`tel:${text}`} 
                                  className="text-blue-600 hover:underline"
                                >
                                  {text}
                                </a>
                              );
                            }

                            return text;
                          }} 
                        />
                        
                        <Table.Column 
                          title="Type" 
                          dataIndex="type" 
                          key="type"
                          render={(text) => {
                            let color = "green";
                            if (text === "Hyperlink") color = "blue";
                            if (text === "Email Address") color = "purple";
                            if (text === "Phone Number") color = "orange";

                            return (
                              <Tag 
                                color={color} 
                                className="px-3 py-0.5 rounded-full text-sm"
                              >
                                {text || "Unknown"}
                              </Tag>
                            );
                          }} 
                        />
                      </Table>
                    ) : (
                      <p className="text-gray-500 italic">No contact details available</p>
                    )}
                  </div>
                )}
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
    </>
  );
}

export default View;
